import { useState } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { getCategoryBySlug } from '../config/portfolio';
import { Lightbox } from '../modules';

function PortfolioCategoryPage() {
  const { slug } = useParams();
  const category = getCategoryBySlug(slug);
  const [activeIndex, setActiveIndex] = useState(null);

  if (!category) {
    return <Navigate to="/portfolio" replace />;
  }

  const openLightbox = (index) => setActiveIndex(index);
  const closeLightbox = () => setActiveIndex(null);

  const changeLightbox = (index) => {
    if (index < 0 || index >= category.photos.length) return;
    setActiveIndex(index);
  };

  return (
    <main className="w-full">
      <h1 className="mb-10 text-center font-sans text-lg uppercase tracking-[0.14em] text-black md:mb-14 md:text-xl">
        {category.title}
      </h1>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
        {category.photos.map((photo, index) => (
          <button
            key={photo}
            type="button"
            onClick={() => openLightbox(index)}
            aria-label="Открыть фото на весь экран"
            className="cursor-pointer overflow-hidden rounded-2xl border-0 bg-neutral-100 p-0"
          >
            <img
              src={photo}
              alt={category.title}
              className="block h-auto w-full object-cover"
              loading="lazy"
            />
          </button>
        ))}
      </div>

      <div className="mt-12 text-center md:mt-16">
        <Link
          to="/portfolio"
          className="font-sans text-xs uppercase tracking-[0.12em] text-neutral-500 no-underline transition-opacity hover:opacity-60"
        >
          ← Назад к портфолио
        </Link>
      </div>

      <Lightbox
        photos={category.photos}
        activeIndex={activeIndex}
        onClose={closeLightbox}
        onChange={changeLightbox}
      />
    </main>
  );
}

export default PortfolioCategoryPage;
